// extracted by mini-css-extract-plugin
export default {"wrapper":"JoinUs_wrapper__7t2Z-","img":"JoinUs_img__OB11d","linear":"JoinUs_linear__E8hZT","text":"JoinUs_text__WS9sG"};